/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Wang Chao
 * @date  2021/7/9 10:51
 * @des  web端cookie相关工具方法
 */
  //import {isWeb} from '@/base/util/platform'

const KEYS = {
    SESSIONID: 'cysessionid',// Cookie中sessionid属性名
    SESSIONID_CY: 'CY', // Cookie中sessionid属性名CY(haproxy服务器标示)
    MAX_SESSION_ALIVE_TIME: 2 * 7 * 24 * 60 * 60 // session在服务器最大超时时间
  }

export function getCookies () {
  var cookies = {}
  var docCookie = document.cookie
  if (docCookie && docCookie !== '') {
    var crumbs = docCookie.split('; ')
    for (var i = crumbs.length - 1; i >= 0; --i) {
      var name, value
      var eqIdx = crumbs[i].indexOf('=')
      if (eqIdx === -1) {
        name = crumbs[i]
        value = ''
      } else {
        name = crumbs[i].substring(0, eqIdx)
        value = crumbs[i].substring(eqIdx + 1)
      }
      cookies[name] = value
    }
  }
  return cookies
}

export function getCookie (cname) {
  let cookies = getCookies()
  return cookies[cname]
}

export function setCookie (name, value, expires, domain, path, secure) {
  let c = name + '=' + value
  if (expires) c += ';expires=' + (new Date(expires)).toGMTString()
  if (domain) c += ';domain=' + domain
  if (path) c += ';path=' + path
  if (secure) c += ';secure'
  document.cookie = c
}

//获取当前SESSIONID
export function getSessionId () {
  return getCookie(KEYS.SESSIONID)
}

// 设置会话Cookie到期时间，刷新cookie
export function setSessionCookieExpires () {
  //if (isWeb()) {
  let expires = new Date().getTime() + KEYS.MAX_SESSION_ALIVE_TIME * 1000
  let SESSIONID_COOKIE = getCookie(KEYS.SESSIONID)
  if (SESSIONID_COOKIE) {
    setCookie(KEYS.SESSIONID, SESSIONID_COOKIE, expires, null, '/', false)
    setCookie(KEYS.SESSIONID_CY, getCookie(KEYS.SESSIONID_CY), expires, null, '/', false)
  }
  //}
}

// 删除会话Cookie
export function removeSessionCookie () {
  //if (isWeb()) {
  document.cookie = `${KEYS.SESSIONID}=; expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`
  //}
}



// WEBPACK FOOTER //
// ./src/base/util/cookieutil.js